import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { locationShape } from 'react-router/lib/PropTypes';
import CSSModules from 'react-css-modules';
import styles from './Application.css';

function Application(props, context) {
  const isOnHomePage = props.location.pathname === '/';

  return (
    <div styleName="application">
      {
        !isOnHomePage ?
          <div styleName="logo-wrapper">
            <div styleName="logo">
              <Link to="/">Jennifer Zwick</Link>
            </div>
          </div> :
        null
      }

      { props.children }
    </div>
  );
}

Application.propTypes = {
  location: locationShape,
  children: PropTypes.node,
};

export default CSSModules(Application, styles);



// WEBPACK FOOTER //
// ./application/js/pages/Application.js